import { render, staticRenderFns } from "./DiscsTest.vue?vue&type=template&id=6977e063&scoped=true&"
import script from "./DiscsTest.vue?vue&type=script&lang=ts&"
export * from "./DiscsTest.vue?vue&type=script&lang=ts&"
import style0 from "./DiscsTest.vue?vue&type=style&index=0&id=6977e063&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6977e063",
  null
  
)

export default component.exports